import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=19889cbc&scoped=true&"
import script from "./Contract.vue?vue&type=script&lang=ts&"
export * from "./Contract.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19889cbc",
  null
  
)

export default component.exports